import { Component, computed, input, Signal } from '@angular/core';
import { ByteConverterPipe } from "../../../shared/pipes/byte-converter.pipe";
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-storage-usage',
  templateUrl: './storage-usage.component.html',
  styleUrls: ['./storage-usage.component.scss'],
  imports: [ByteConverterPipe, DecimalPipe]
})
export class StorageUsageComponent {
  readonly segments = input.required<{ label: string, value: number, color: string }[]>();
  readonly totalAvailable = input.required<number>();
  readonly loading = input.required<boolean>();

  readonly totalUsed = computed(() =>
    this.segments().reduce((sum, s) => sum + s.value, 0)
  );

   readonly segmentsWithPercentage: Signal<{ label: string, value: number, percentage: number, color: string }[]> = computed(() =>
    this.segments().map(s => ({
      ...s,
      percentage: (s.value / this.totalAvailable()) * 100
    }))
  );
}
